export default "__VITE_ASSET__CTX2PbuM__"